module.exports = __webpack_public_path__ + "img/bgalpha_beastreserve.d22f8e6.png";